import React, {useEffect, useState} from "react";
import { makeStyles } from "@material-ui/core/styles";
import StarRatings from 'react-star-ratings';
import {IoClose } from "react-icons/io5";

const useStyles = makeStyles((theme) => ({
    card: { 
        marginBottom: '20px',
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '20px',
       
    },
    cardTitle: {
        fontFamily: 'Poppins',
        fontSize: '18px',
        fontWeight: 600,
        marginBottom: '10px',
    },
    cardText: {
        fontFamily: 'Poppins',
        fontSize: '14px',
        fontWeight: 500,
        lineHeight : '21px',
        color: 'rgba(128, 128, 143, 1)',
        padding : '5px'
    },
    cardValue: {
        fontFamily: 'Poppins',
        fontSize: '14px',
        fontWeight: 500,
        color: 'rgba(24, 28, 50, 1)',
        lineHeight : '21px' , 
        textAlign : 'Right',
        padding : '5px'
    },
    TextContainer: {
        display: 'flex',
        justifyContent: 'space-between',

    }

}));

const getPhone = (partyCommunicationChannels) => {
    const Channel = partyCommunicationChannels?.find(party => party.communicationChannel?.type === "PHONECONTACT" &&  party.status === "ACTIVE");
    const phoneValue = Channel ? Channel.communicationChannel.value : "N/A"
    return phoneValue
  }

const getEmail = (partyCommunicationChannels) => {
    const Channel = partyCommunicationChannels?.find(party => party.communicationChannel?.type === "EMAILCONTACT" &&  party.status === "ACTIVE");
    const emailValue = Channel ? Channel.communicationChannel.value : "N/A"
    return emailValue
  }

const getAdresse = (partyAddresses) => {
    if(!partyAddresses){
        return "N/A"
    }
    const address = partyAddresses[0]?.address?.number+" "+ partyAddresses[0]?.address?.street+" "+partyAddresses[0]?.address?.state?.label+" "+partyAddresses[0]?.address?.postalCode?.postalCode
    if(address.includes("undefined")){
      return "N/A"
    }else {
      return address || {}
    }
  }
  function getGouvernorat(inspectorCaracteristiques) { 
    const Caracteristique = inspectorCaracteristiques?.find(item => item.key === "GOUVERNORAT" );
    const Gouvernorat = Caracteristique ? Caracteristique.value : "N/A"
    return Gouvernorat   
    }
 
function getRegion(inspectorCaracteristiques) { 
    const Caracteristique = inspectorCaracteristiques?.find(item => item.key === "REGION" );
    const REGION = Caracteristique ? Caracteristique.value : "N/A"
    return REGION   
    }

const ExpertCart = ({ filteredInspectors ,designated , restDesignated, width  ,  height, selectedInspector}) => {
    const classes = useStyles();
    //console.log("filteredInspectors", filteredInspectors)

    const [personDetails, setPersonDetails] = useState(null);

    useEffect(() => {
                    setPersonDetails(filteredInspectors.personDetails);
    }, [filteredInspectors?.associatedParty]);
//console.log('personDetails' ,JSON.stringify(filteredInspectors)  )
    const calculateStarRating = (note) => {
            return note / 2 ||"N/A"; // if note is out of 10, convert to 5-star rating
    };

    const isSelected = selectedInspector && selectedInspector._id === filteredInspectors._id;
    
    return (
        <div className={classes.card} style ={{
            width: width, 
            height: height,  
            border: width === "100%" 
                ? '0.61px solid rgba(226, 217, 239, 1)' 
                : isSelected 
                    ? '2px solid rgb(60, 101, 86)' 
                    : 'none'
        }} onClick={designated}>
                        <div className={classes.TextContainer}>
                            <div className={classes.cardTitle}>{personDetails?.name}{" "}{personDetails?.lastName}</div>
                           {filteredInspectors.ToPlan  && width != "100%" &&
                            <div style={{width: "60px",
                            height: "26px", 
                            borderRadius: '51px',
                            background:'rgba(240, 243, 199, 1)',
                            fontFamily: 'Poppins',
                            fontSize: '12px',
                            fontWeight: 500,
                            lineHeight: '16px',
                            textAlign: 'center',
                            color:'rgba(187, 200, 8, 1)',
                            padding :'5px',
                            marginRight: '5px'
                            }} >Planifié</div>} 
                            {width === "100%" ?<IoClose  size={25}   style={{ color: 'rgba(187, 200, 8, 1)', cursor: 'pointer', }} onClick={restDesignated}/>:<></>}
                        </div>
                        
                        <div className={classes.TextContainer}>
                                    <div className={classes.cardText}>Gouvernorat :</div>
                                    <div className={classes.cardValue}>{getGouvernorat(filteredInspectors?.inspectorCaracteristiques)}</div>
                        </div>
                        <div className={classes.TextContainer}>
                                <div className={classes.cardText}>Region : </div>
                                <div className={classes.cardValue}>{getRegion(filteredInspectors?.inspectorCaracteristiques)}</div>
                        </div>
                        <div className={classes.TextContainer}>
                                    <div className={classes.cardText}>Adresse :</div>
                                    <div className={classes.cardValue}>{getAdresse(personDetails?.partyAddresses)}</div>
                        </div>
                        <div className={classes.TextContainer}>
                                    <div className={classes.cardText}>Tel :</div>
                                    <div className={classes.cardValue}>{getPhone(personDetails?.partyCommunicationChannels)}</div>
                        </div>
                        <div className={classes.TextContainer}>
                                    <div className={classes.cardText}>Email  :</div>
                                    <div className={classes.cardValue}>{getEmail(personDetails?.partyCommunicationChannels)}</div>
                        </div>
                        {/* <div className={classes.TextContainer}>
                                    <div className={classes.cardText}>Délais de prise de RDV:</div>
                                    <div
                                        className={classes.cardValue}>{filteredInspectors?.performanceKPI?.totalMissionsCurrentMonth }</div>
                        </div>
                        <div className={classes.TextContainer}>
                                <div className={classes.cardText}>Délais moyen d'expertise: </div>
                                <div className={classes.cardValue}> 0</div>
                        </div>
                        <div className={classes.TextContainer}>
                                <div className={classes.cardText}>Délais moyen de remise de rapport: </div>
                                <div className={classes.cardValue}>0 </div>
                        </div>
                        <div className={classes.TextContainer}>
                                <div className={classes.cardText}>Nombre de fraude détectée:</div>
                                <div className={classes.cardValue}>{filteredInspectors?.performanceKPI?.numberOfFraudsDetected }</div>
                        </div>
                        <div className={classes.TextContainer}>
                                <div className={classes.cardText}>Montant de fraude économisé:</div>
                                <div className={classes.cardValue}> {filteredInspectors?.performanceKPI?.amountOfFraudSaved } </div>
                        </div>
                        <div className={classes.TextContainer}>
                            <div className={classes.cardText}>Nombre de mission en cours: </div>
                            <div className={classes.cardValue}>0</div>
                        </div>
                        <div className={classes.TextContainer}>
                            <div className={classes.cardText}>Total missions (mois en cours): </div>
                            <div className={classes.cardValue}>{filteredInspectors?.performanceKPI?.totalMissionsCurrentMonth }</div>
                        </div>
                        <div className={classes.TextContainer}>
                            <div className={classes.cardText}>Total missions (année en cours):</div>
                            <div className={classes.cardValue}> {filteredInspectors?.performanceKPI?.totalMissionsCurrentYear || 0}</div>
                        </div>
                        <div className={classes.TextContainer}>
                            <div className={classes.cardText}>Cout moyen expert: </div>
                            <div className={classes.cardValue}>0</div>
                        </div>
                        <div className={classes.TextContainer}>
                            <div className={classes.cardText}>Qualité de service: </div>
                            <div className={classes.cardValue}>
                                <StarRatings
                                    rating={calculateStarRating(10)}
                                    starRatedColor="rgba(187, 200, 8, 1)"
                                    numberOfStars={5}
                                    starDimension="18px"
                                    starSpacing="2px"
                                />   </div>
                         </div>
                        <div className={classes.TextContainer}>
                            <div className={classes.cardText}>Note expert: </div>
                            <div className={classes.cardValue}>{calculateStarRating(filteredInspectors?.noteExpert)}</div>
                        </div> */}
                    </div>
    );
}

export default ExpertCart;